<app-auth-pages>
  <ng-container *transloco="let t;">
    @if (showResetForm) {
      <h2 class="card-title fw-bold mb-1">SimpleSign</h2>
      <p class="card-text mb-2">{{ t('Your email is verified. Please choose a new password to continue.') }}</p>

      <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
        <div class="alert-body">
          <p>{{ error }}</p>
        </div>
      </ngb-alert>

      @if (changePasswordSucceeded) {
        <ngb-alert [type]="'success'" [dismissible]="false">
          <div class="alert-body">
            <p>{{ t('Change password success message (Reset password page) - Password has been changed successfully. You will be redirected into login page in n seconds', { seconds: redirectTimeout }) }}</p>
          </div>
        </ngb-alert>
      } @else {
        <form class="auth-register-form mt-2" autocomplete="off" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="password" class="form-label">{{ t('Password - label (general) - Password') }}</label>
            <app-password-field formControlName="password" id="password" tabindex="3"></app-password-field>
            <ng-container
              *ngTemplateOutlet="errorMessage; context: {
                  invalid: changePasswordForm.invalid,
                  submitted: submitted,
                  formField: changePasswordForm.controls['password'],
                  fieldName: t('Password - label (general) - Password')
                }"
            ></ng-container>
          </div>

          <div class="form-group">
            <label for="confirm-password" class="form-label">{{ t('Confirm Password - label (general) - Confirm password') }}</label>
            <app-password-field formControlName="confirmPassword" id="confirm-password" tabindex="3"></app-password-field>
            <ng-container
              *ngTemplateOutlet="errorMessage; context: {
                  invalid: changePasswordForm.invalid,
                  submitted: submitted,
                  formField: changePasswordForm.controls['confirmPassword'],
                  fieldName: t('Confirm Password - label (general) - Confirm password')
                }"
            ></ng-container>
          </div>

          <div class="form-group">
            <div *ngIf="submitted && changePasswordForm.invalid" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && changePasswordForm.invalid }">
              <div *ngIf="changePasswordForm.hasError('passwordsMustMatch')">
                {{ t('Fields must match each other (field matches validation) - a field must match b field', { fieldA: t('Password - label (general) - Password'), fieldB: t('Confirm Password - label (general) - Confirm password') }) }}
              </div>
            </div>
          </div>

          <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>{{ t('Update button text (update button) - update') }}
          </button>
        </form>
      }

      <p class="text-center mt-2">
        <a routerLink="/login"><span>&nbsp;{{ t('Sign in instead text (Authorization pages) - Sign in instead') }}</span></a>
      </p>

      <ng-template #errorMessage let-formField="formField" let-submitted="submitted" let-invalid="invalid" let-fieldName="fieldName">
        <div *ngIf="submitted && invalid" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && invalid }">
          <div *ngIf="formField.hasError('required')">{{ t('Field required (form validation) - Field name is required', { fieldName: fieldName }) }}</div>
          <div *ngIf="formField.hasError('pattern')">
            {{ t('New Password field validation message (Change password - section) - New Password must contain more than 8 characters 1 numeric 1 upper case letter and 1 special character') }}
          </div>
        </div>
      </ng-template>
    }
    @else {
      @if (validated) {
        <h2 class="card-title fw-bold mb-1">{{ t('Displaying heading on the email verfication page (Email verified Heading) Your email address is Verified') }}</h2>
        <p class="card-text mb-2">{{ t('Displaying description on the email verfication page (email verification message) Thank you for the email verification') }}.</p>
        <p class="text-center mt-2">
          <a routerLink="/login"><span>&nbsp;{{ t('Sign in instead text (Authorization pages) - Sign in instead') }}</span></a>
        </p>
      }
      @else {
        <h2 class="card-title fw-bold mb-1">{{ t('Displaying heading on the email verfication page (Email verification failed Heading) Email has not verified') }}</h2>
        <p class="card-text mb-2">{{ t('Displaying description on the email verfication page (Email verification failed description) Your link is not valid for the email verification') }}.</p>
      }
    }
  </ng-container>
</app-auth-pages>